<script>
import PartCard from "@/router/views/products/v2/PartCard";
import { loadStoredConfig } from "@/router/views/products/v2/storedConfig";
import {
  ITEM_CARD_CONFIG_KEY,
  DEFAULT_ITEM_CARD_CONFIG,
} from "@/router/views/products/v2/itemCardConfig";

export default {
  components: { PartCard },
  data() {
    return {
      showModal: false,
      allParts: false,
      parts: [],
      config: null,
      close: null,
      confirm: null,
    };
  },
  methods: {
    openAlertEventDialog: function (data) {
      this.config = loadStoredConfig(
        ITEM_CARD_CONFIG_KEY,
        DEFAULT_ITEM_CARD_CONFIG,
      );
      this.allParts = false;
      this.parts = data;
      this.showModal = true;
      return new Promise((resolve, reject) => {
        this.confirm = () => {
          if (this.allParts) {
            resolve([]);
          }
          resolve(this.parts.filter((x) => x.isDamaged).map((x) => x.idPublic));
        };
        this.close = () => {
          reject();
        };
      }).finally(() => {
        this.showModal = false;
        setTimeout(() => {
          this.parts = [];
        }, 500);
      });
    },
    togglePart(part) {
      part.isDamaged = !part.isDamaged;
    },
  },
  watch: {
    allParts(value) {
      for (var i = 0; i < this.parts.length; i++) {
        this.parts[i].isDamaged = value;
      }
    },
  },
};
</script>

<template>
  <b-modal
    v-model="showModal"
    :title="$t('general.alert')"
    title-class="text-black font-18"
    scrollable
    body-class="p-3"
    id="alertPartModalV2"
  >
    <p>{{ $t("general.pleasechoosedamagedparts") }}</p>
    <label class="parts-lbl">{{ $t("general.parts") }} :</label>
    <div class="all-parts-row" @click="allParts = !allParts">
      <span>{{ $t("general.allparts") }}</span>
      <b-form-checkbox switch v-model="allParts" @click.native.stop />
    </div>
    <div class="parts-list">
      <PartCard
        v-for="(part, index) in parts"
        :key="part.idPublic || index"
        :part="part"
        :config="config"
        selectable
        :checked="part.isDamaged"
        @toggle="togglePart(part)"
      />
    </div>
    <template #modal-footer class="text-right pt-3">
      <b-button variant="light" @click="close()">{{
        $t("general.close")
      }}</b-button>
      <b-button variant="light" @click="confirm()">{{
        $t("general.confirm")
      }}</b-button>
    </template>
  </b-modal>
</template>
<style scoped>
.parts-lbl {
  font-size: 12px;
  font-weight: 600;
  color: #7a8a99;
  margin-bottom: 6px;
}
.all-parts-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 11px;
  background: #f4f6f8;
  border: 1px solid #e0e5ea;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 600;
  color: #1c2e3e;
  cursor: pointer;
  margin-bottom: 8px;
}
.parts-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
</style>
